function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n        color: #f44336;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { css } from "@emotion/react";
import { Typography } from "@mui/material";
var ErrorMessage = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Typography, {
        variant: "caption",
        css: css(_templateObject()),
        children: children
    });
};
export default /*#__PURE__*/ React.memo(ErrorMessage);
